module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099NJ13XD.cf363a64.jpg";